import { memo } from 'react';
import type { IbanXsBank } from 'features/openBanking/types';
import Tabs from 'ui/atoms/Tabs';
import {
    useResourceContext,
    ResourceDetail,
    type ResourceDetailProps
} from "ui/widgets/Resource";
import {
    EditIbanXSDetailResourceForm,
    ManageIbanXSBanksCountriesPivot,
    IbanXSBanksCountriesPivotProvider,
    IbanXSBanksCountriesPivotLabel,
    ManageIbanXSBanksRecipientsPivot
} from './tabs';

const IbanXSDetail = (props: ResourceDetailProps) => {
    const { onClose } = useResourceContext<IbanXsBank>();

    return (
        <ResourceDetail
            {...props}
            disableCloseOnBackdropClick
            onClose={onClose}
        >
            <IbanXSBanksCountriesPivotProvider>
                <Tabs
                    model={[
                        {
                            label: 'Edit Iban XS Resource',
                            component: (
                                <EditIbanXSDetailResourceForm />
                            )
                        },
                        {
                            label: 'Manage Open Banking Recipients',
                            component: (
                                <ManageIbanXSBanksRecipientsPivot />
                            ),
                            sxProps: {
                                pt: 0
                            }
                        },
                        {
                            label: (
                                <IbanXSBanksCountriesPivotLabel />
                            ),
                            component: (
                                <ManageIbanXSBanksCountriesPivot />
                            )
                        }
                    ]}
                    TabListContainerProps={{
                        borderBottom: 1,
                        borderColor: 'divider'
                    }}
                    TabListProps={{
                        'aria-label': 'iban xs details',
                        variant: 'scrollable',
                        scrollButtons: 'auto'
                    }}
                />
            </IbanXSBanksCountriesPivotProvider>
        </ResourceDetail>
    );
};

export default memo(IbanXSDetail);
